import { render } from "./ArrowReturn.vue?vue&type=template&id=7d4b981c"
const script = {}
script.render = render

export default script